export const MONEY = {
    CURRENCY:                   '$0,0.00',
    CURRENCY_NO_PRECISION:      '$0,0',
    CURRENCY_UNIT:              '($0,0.00 a)',
    CURRENCY_NO_PRECISION_UNIT: '($0,0 a)',
};

export const MATH = {
    PERCENTAGE:              '0,0.00%',
    PERCENTAGE_NO_PRECISION: '0,0%',
};

export const COMMUNICATION = {
    PHONESTYLE:  'National',
    PHONEREGION: 'US'
};

export const DATES = {
    MONTH_ABBR:                 'MMM',
    MONTHYEAR_ABBR:             'MMM YYYY',
    MONTHDAYYEAR_ABBR:          'MMM DD, YYYY',
    MONTHDAYYEAR_ABBR_ORDINAL:  'MMM Do, YYYY',
    MONTHDAY_ABBR:              'MMM DD',
    MONTHDAY_UNPADDED_ABBR:     'MMM D',
    MONTHDAY_SLASHED:           'M/DD',
    MONTH_FULL:                 'MMMM',
    MONTHDAYYEAR_DASHED:        'MM-DD-YYYY',
    MONTHDAYYEAR_SLASHED:       'MM/DD/YYYY',
    MONTHDAYYEAR_SLASHED_SHORT: 'M/D/YY',
    YEARMONTHDAY_MOMENT:        'YYYY-MM-DD',
    YEARQUARTER_MOMENT:         'YYYY-Q'
};

export const TIME = {
    TIME_MERIDIEM: 'h:mma',
};

export const USERNAMES = {
    FULL:                0,
    FULL_LASTNAME_FIRST: 1,
    SHORT:               2,
    INITIALS:            3,
};

export const STRING_CONVERSION = {
    NEWLINE_STANDIN:            '[BREAK]',
    NEWLINE_REGEX:              /([\s]?\n+)/gi,
    DELIMITER:                  '|',
    SEARCH_DELIMITER:           '|',
    SEARCH_GROUP_DELIMITER:     '+',
    SEARCH_NEGATION_PREFIX:     '!',
    SEARCH_EXACT_CASING_SUFFIX: '*',
    SPACE:                      ' ',
    PLACEHOLDER:                '%PLACEHOLDER%',
}

export const ALPHABET = [ 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z' ]
export const ALPHABET_UPPERCASE = ALPHABET.map( letter => letter.toUpperCase() );

export const EMPTY_VALUE_DISPLAY = '--'
